import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { upsertAdminUser } from '../../api/adminUsersApi';
import AdminInvitesSection from '../../invitations/components/AdminInvitesSection';
import { ADMIN_PATHS, adminPath } from '../../constants/adminPaths';
import '../admin-management/InviteCreateAdmin.css';

const InviteCreateAdmin = () => {
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [newAdminRole, setNewAdminRole] = useState('admin');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');
      
      await upsertAdminUser({
        email,
        password,
        role: newAdminRole,
      });

      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setNewAdminRole('admin');
      setSuccess('Admin account created successfully!');
      
    } catch (err) {
      console.error('Error creating admin:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="invite-create-admin-page">
      <div className="invite-create-admin-header">
        <button 
          className="invite-create-admin-back"
          onClick={() => navigate(adminPath(ADMIN_PATHS.ADMIN_MANAGEMENT_CREATE))}
        >
          ← Back to Admin Management
        </button>
        <h1>Invite & Create Admin</h1>
        <p>Invite support/admin users or create new admin accounts</p>
      </div>

      {error && (
        <div className="invite-create-admin-alert invite-create-admin-alert-error">
          <span>⚠️</span>
          <span>{error}</span>
        </div>
      )}

      {success && (
        <div className="invite-create-admin-alert invite-create-admin-alert-success">
          <span>✓</span>
          <span>{success}</span>
        </div>
      )}

      {/* Invites and Create Admin Sections Side by Side */}
      <div className="invite-create-admin-sections-row">
        {/* Invites Section */}
        <div className="invite-create-admin-invites-section">
          <h2 className="invite-create-admin-section-title">Invite Support/Admin Users</h2>
          <AdminInvitesSection showHeader={false} />
        </div>

        {/* Create Admin Section */}
        <div className="invite-create-admin-create-section">
          <h2 className="invite-create-admin-section-title">Create New Admin Account</h2>
          <form onSubmit={handleSubmit} className="invite-create-admin-form">
            <div className="invite-create-admin-form-group">
              <label className="invite-create-admin-label">Email Address</label>
              <input
                type="email"
                className="invite-create-admin-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="admin@example.com"
              />
            </div>

            <div className="invite-create-admin-form-group">
              <label className="invite-create-admin-label">Role</label>
              <select
                className="invite-create-admin-select"
                value={newAdminRole}
                onChange={(e) => setNewAdminRole(e.target.value)}
              >
                <option value="admin">Admin</option>
                <option value="support">Support</option>
              </select>
            </div>

            <div className="invite-create-admin-form-row">
              <div className="invite-create-admin-form-group">
                <label className="invite-create-admin-label">Password</label>
                <input
                  type="password"
                  className="invite-create-admin-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter password"
                />
              </div>

              <div className="invite-create-admin-form-group">
                <label className="invite-create-admin-label">Confirm Password</label>
                <input
                  type="password"
                  className="invite-create-admin-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  placeholder="Confirm password"
                />
              </div>
            </div>

            <button
              type="submit"
              className="invite-create-admin-btn invite-create-admin-btn-primary"
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create Admin'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InviteCreateAdmin;
